import React from 'react';

import clsx from 'clsx';

interface SidebarIconProps {
  state: 'default' | 'selected' | 'disabled';
  className: string;
  text: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  iconSelected?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onClick?: () => void;
  'data-qa-selector'?: string;
}

export const SidebarIcon: React.FC<SidebarIconProps> = ({
  className,
  state = 'default',
  icon: Icon,
  iconSelected: IconSelected,
  text = 'Settings',
  onClick,
  'data-qa-selector': dataQaSelector,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={state === 'disabled'}
      data-qa-selector={dataQaSelector}
      className={clsx(
        'group flex h-16 w-16 flex-col items-center justify-center gap-1 rounded-md px-1 py-2.5 transition-all',
        className,
        {
          'cursor-pointer text-neutral-900 hover:bg-neutral-100': state === 'default',
          'cursor-pointer bg-indigo-500 text-white': state === 'selected',
          'cursor-not-allowed text-neutral-200': state === 'disabled',
        },
      )}
    >
      {typeof Icon === 'function' &&
        (state === 'default' || state === 'disabled' || IconSelected === null) && (
          <>
            <Icon className="flex h-5 min-h-5 w-5 min-w-5 transition-all group-hover:hidden" />
            {IconSelected ? (
              <IconSelected className="hidden h-5 min-h-5 w-5 min-w-5 transition-all group-hover:flex" />
            ) : null}
          </>
        )}
      {IconSelected && state === 'selected' ? (
        <IconSelected className="h-5 min-h-5 w-5 min-w-5 transition-all" />
      ) : null}

      {text !== '' && (
        <>
          <span className="text-center text-[10px] leading-none font-medium">{text}</span>
        </>
      )}
    </button>
  );
};
